import {Component, OnInit} from '@angular/core';
import {HttpApiService} from "../../../services/http-api.service";
import {EndpointsService} from "../../../services/endpoints.service";
import {Constants} from "../../../services/constants";

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html'
})
export class ForgotPasswordComponent implements OnInit {

  isRequested: boolean = false;
  isRequesting: boolean = false;
  errorMessage: any;

  constructor(private Api: HttpApiService,
              private endpoints: EndpointsService) {
  }

  ngOnInit() {
  }

  submit(username) {
    if(!username) {
      return false;
    }
    this.requestResetPassword(username)
    return false;
  }

  requestResetPassword(username) {
    this.errorMessage = null;
    this.isRequesting=true;
    this.Api.put(this.endpoints.getForgotPasswordUrl() + "?username=" + username + "&domain=" + Constants.TENANT_ID(), {}, false)
      .subscribe(response => {
          this.isRequested = true;
          this.isRequesting = false;
        },
        error => {
          this.errorMessage = JSON.parse(error._body).message;
          this.isRequesting = false;
        })
  }

}



// WEBPACK FOOTER //
// ./src/app/components/user/forgot-password/forgot-password.component.ts